module.exports = __webpack_public_path__ + "img/sterownik-4.7325343f.jpg";